/*/////////////////////////////////////////////////////////////////
//    FileName: setting.js
//    Author: Ramzi TM
//    Created On: 6-Apr-2022
//    Last Modified On: 6-Apr-2022
//    Copy Rights: Orinno Technology Pte Ltd
//    Description: customerSectorName details DIV component, 
//                 will display at beside home page drawer if called.
*/ /////////////////////////////////////////////////////////////////

import React, { Component, Fragment } from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  Card,
  CardContent,
  Divider,
  Button,
  Grid,
  TextField,
} from "@material-ui/core";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import clsx from "clsx";
import axios from "axios";
import { authMiddleWare } from "../util/auth.js";
import { baseURL } from "../util/port.js";
import { confirmAlert } from "react-confirm-alert"; // Import
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as XLSX from "xlsx";

//main class component
class customerSectorName extends Component {
  constructor(props) {
    super(props);

    //state variable
    this.state = {
      uiLoading: false,
      loading: false,
      sectorList: [],
      sectorSelected: null,
      sectorCustomer: "",
      errors: [],
      errMsg: "",
      sheet0: "",
      col0: [],
      row0: [],
      allData: [],
    };

    this.handleGetData = this.handleGetData.bind(this);
  }

  //will run once everytime the page render
  componentDidMount = async () => {
    const authToken = localStorage.getItem("AuthToken");
    //request API to get all sector data
    authMiddleWare(this.props.history);
    if (authToken == null) {
      alert("Your session is expired, please login to retry.");
      this.setState({ uiLoading: false });
      this.props.setLogin(false);
    } else {
      axios.defaults.headers.common = { Authorization: `${authToken}` };
      await axios
        .get(`${baseURL}/getSector`)
        .then((response) => {
          let fixData = [];
          response.data.forEach((data) => {
            fixData.push(`${data.siteBase}`);
          });
          this.setState({
            sectorList: fixData,
          });
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 403) {
            alert("Your session is expired, please login to retry.");
            this.setState({ uiLoading: false });
            this.props.setLogin(false);
          }
        });
    }

    await this.handleGetData();
  };

  handleGetData = async () => {
    this.setState({ uiLoading: true });
    const authToken = localStorage.getItem("AuthToken");
    //request API to get all site data
    authMiddleWare(this.props.history);
    if (authToken == null) {
      alert("Your session is expired, please login to retry.");
      this.setState({ uiLoading: false });
      this.props.setLogin(false);
    } else {
      axios.defaults.headers.common = { Authorization: `${authToken}` };
      await axios
        .get(`${baseURL}/customerSectorName`)
        .then((response) => {
          console.log(response.data);
          this.setState({
            allData: response.data,
            uiLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          if (err?.response?.status === 403) {
            alert("Your session is expired, please login to retry.");
            this.setState({ uiLoading: false });
            this.props.setLogin(false);
          }
        });
    }
  };

  //delete dialogbox
  handleDelete = (data) => {
    confirmAlert({
      title: "Confirm to delete the record?",
      // message: 'This might affect all others related data.',
      buttons: [
        {
          label: "Delete",
          onClick: async () => {
            this.setState({ uiLoading: true });
            authMiddleWare(this.props.history);
            const authToken = localStorage.getItem("AuthToken");
            if (authToken == null) {
              alert("Your session is expired, please login to retry.");
              this.setState({ uiLoading: false });
              this.props.setLogin(false);
            } else {
              axios.defaults.headers.common = { Authorization: `${authToken}` };
              //send request to delete site db
              await axios
                .delete(`${baseURL}/customerSectorName/${data.id}`)
                .then(async () => {
                  await this.handleGetData();
                  this.setState({
                    uiLoading: false,
                    errors: [],
                  });
                })
                .catch((err) => {
                  if (err.response.status === 403) {
                    alert("Your session is expired, please login to retry.");
                    this.setState({ uiLoading: false });
                    this.props.setLogin(false);
                  }
                  console.log(err);
                });
            }
          },
        },
        {
          label: "Cancel",
          onClick: () => onclose,
        },
      ],
    });
  };

  //render function
  render() {
    let uploadbtn = null;

    //trigger reset
    const handleReset = () => {
      if (uploadbtn) uploadbtn.value = "";
      this.setState({
        sheet0: "",
        col0: [],
        row0: [],
      });
    };

    //trigger event upload customerSectorName
    const handleUploadDropOffPoint = () => {
      confirmAlert({
        title: "Confirm to push the data to customerSectorName?",
        message: "Make sure to double check the data, or duplication.",
        buttons: [
          {
            label: "Submit",
            onClick: async () => {
              this.setState({ uiLoading: true });
              const authToken = localStorage.getItem("AuthToken");
              const options = {
                url: `${baseURL}/customerSectorName`,
                method: "post",
                data: {
                  data: this.state.row0,
                },
              };
              axios.defaults.headers.common = { Authorization: `${authToken}` };
              await axios(options)
                .then(async (res) => {
                  console.log(res);
                  handleReset();
                  await this.handleGetData();
                  this.setState({ uiLoading: false });
                })
                .catch((error) => {
                  if (error.response?.status === 403) {
                    alert("Your session is expired, please login to retry.");
                    this.setState({ uiLoading: false });
                    this.props.setLogin(false);
                  }
                  console.log(error);
                });
            },
          },
          {
            label: "Cancel",
            onClick: () => onclose,
          },
        ],
      });
    };

    //trigger event add customerSectorName
    const handleAddDropOffPoint = () => {
      confirmAlert({
        title: "Confirm to push the data to customerSectorName?",
        message: "Make sure to double check the data, or duplication.",
        buttons: [
          {
            label: "Submit",
            onClick: async () => {
              this.setState({ uiLoading: true });
              const authToken = localStorage.getItem("AuthToken");
              const options = {
                url: `${baseURL}/customerSectorName`,
                method: "post",
                data: {
                  data: [
                    {
                      sectorSystem: this.state.sectorSelected,
                      sectorCustomer: this.state.sectorCustomer,
                    },
                  ],
                },
              };
              axios.defaults.headers.common = { Authorization: `${authToken}` };
              await axios(options)
                .then(async (res) => {
                  console.log(res);
                  handleReset();
                  await this.handleGetData();
                  this.setState({
                    uiLoading: false,
                    sectorSelected: null,
                    sectorCustomer: "",
                  });
                })
                .catch((error) => {
                  if (error.response?.status === 403) {
                    alert("Your session is expired, please login to retry.");
                    this.setState({ uiLoading: false });
                    this.props.setLogin(false);
                  }
                  console.log(error);
                });
            },
          },
          {
            label: "Cancel",
            onClick: () => onclose,
          },
        ],
      });
    };

    const onChange = (e) => {
      this.setState({ uiLoading: true });
      const [file] = e.target.files;
      if (file) {
        const reader = new FileReader();

        reader.onload = async (evt) => {
          const bstr = evt.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          const wsname0 = wb.SheetNames[0];
          const ws0 = wb.Sheets[wsname0];
          const data0 = XLSX.utils.sheet_to_json(ws0, {
            header: 1,
            blankrows: false,
          });

          const row0 = data0.slice(1).map((r) =>
            r.reduce((acc, x, i) => {
              acc[data0[0][i]] = x;
              return acc;
            }, {})
          );

          const row0fix = row0.map((v) => {
            return {
              ...v,
            };
          });
          const col0fix = data0[0].map((r) => r);

          this.setState(
            {
              sheet0: wsname0,
              col0: col0fix,
              row0: row0fix,
            },
            () => {
              this.setState({ uiLoading: false });
            }
          );
        };
        reader.readAsBinaryString(file);
      }
    };

    const { classes } = this.props;
    const { sheet0, col0, row0, allData } = this.state;

    //loading UI
    if (this.state.uiLoading === true) {
      return (
        <main className={classes.content}>
          <div className={classes.toolbar} />
          {this.state.uiLoading && (
            <CircularProgress size={150} className={classes.uiProgess} />
          )}
        </main>
      );
    } else {
      //if not loading, return actual UI and dialogbox
      return (
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <Card className={clsx(classes.root, classes)}>
            <CardContent>
              <div className={classes.details}>
                <div>
                  <Typography
                    className={classes.locationText}
                    gutterBottom
                    variant="h4"
                  >
                    Customer Sector Name
                  </Typography>
                </div>
              </div>
              <div className={classes.progress} />
            </CardContent>
            <Divider />
          </Card>

          <br />
          <Grid
            container
            spacing={4}
            alignItems="center"
            justifycontent="space-between"
          >
            <Grid item xs={10}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={3}>
                  <Autocomplete
                    style={{ width: "100%" }}
                    options={this.state.sectorList}
                    id={"sector"}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Sector"
                        id={"sector"}
                        required
                      />
                    )}
                    onChange={(event, value) => {
                      this.setState({ sectorSelected: value, errMsg: "" });
                    }}
                    value={this.state.sectorSelected}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    onChange={(event) => {
                      this.setState({ sectorCustomer: event.target.value });
                    }}
                    id="sectorCustomer"
                    label="Customer Sector Name"
                    name="sectorCustomer"
                    autoComplete="sectorCustomer"
                    value={this.state.sectorCustomer}
                    color="primary"
                  />
                </Grid>
                <Grid item xs={4}>
                  <Button
                    disabled={
                      this.state.sectorSelected === null ||
                      this.state.sectorCustomer === ""
                    }
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => handleAddDropOffPoint()}
                  >
                    Add Name
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2}>
              <input
                onChange={onChange}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                className={classes.input}
                id="contained-button-file"
                type="file"
                ref={(ref) => (uploadbtn = ref)}
              />
              <label htmlFor="contained-button-file">
                <Button
                  disabled={sheet0 !== ""}
                  variant="contained"
                  color="primary"
                  component="span"
                  size="large"
                >
                  Upload File
                </Button>
                {sheet0 !== "" && (
                  <Button
                    color="primary"
                    variant="contained"
                    component="span"
                    size="large"
                    onClick={() => handleReset()}
                    style={{ marginLeft: "15px" }}
                  >
                    Reset All
                  </Button>
                )}
              </label>
            </Grid>
          </Grid>

          {!!row0.length && (
            <>
              <Divider
                variant="middle"
                style={{ marginTop: 30, marginBottom: 30, width: "100%" }}
              />
              <Grid container spacing={4} justifycontent="space-between">
                <Grid item xs={6}>
                  <Typography variant="h5">From File</Typography>
                </Grid>
                <Grid item xs={6} style={{ textAlign: "right" }}>
                  <Button
                    color="primary"
                    variant="contained"
                    className={classes.addButton}
                    onClick={() => handleUploadDropOffPoint()}
                  >
                    Save to database
                  </Button>
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Paper className={classes.paperTable}>
                    <Table stickyHeader className={classes.table}>
                      <TableHead>
                        <TableRow>
                          {!!col0.length &&
                            col0.map((item, i) => (
                              <Fragment key={`col-${i}`}>
                                <TableCell>{item}</TableCell>
                              </Fragment>
                            ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!!row0.length &&
                          row0.map((item, i) => (
                            <Fragment key={`row-${i}`}>
                              <TableRow>
                                <TableCell>{item.sectorSystem}</TableCell>
                                <TableCell>{item.sectorCustomer}</TableCell>
                              </TableRow>
                            </Fragment>
                          ))}
                      </TableBody>
                    </Table>
                  </Paper>
                </Grid>
              </Grid>
            </>
          )}

          <Divider
            variant="middle"
            style={{ marginTop: 30, marginBottom: 30, width: "100%" }}
          />
          <Grid container spacing={4} justifycontent="space-between">
            <Grid item xs={12}>
              <Typography variant="h5">From Database</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper className={classes.paperTable}>
                <Table stickyHeader className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sector Real Name</TableCell>
                      <TableCell>Sector Customer Name</TableCell>
                      <TableCell>Created At</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!!allData.length &&
                      allData.map((item, i) => (
                        <Fragment key={`row-${i}`}>
                          <TableRow>
                            <TableCell>{item.sectorSystem}</TableCell>
                            <TableCell>{item.sectorCustomer}</TableCell>
                            <TableCell>
                              {new Date(
                                item.createdAt?.seconds * 1000
                              ).toLocaleString()}
                            </TableCell>
                            <TableCell>
                              <Button
                                style={{}}
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={() => this.handleDelete(item)}
                              >
                                Delete
                              </Button>
                            </TableCell>
                          </TableRow>
                        </Fragment>
                      ))}
                  </TableBody>
                </Table>
              </Paper>
            </Grid>
          </Grid>
        </main>
      );
    }
  }
}

//styles
const styles = (theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: "1400px",
  },
  toolbar: theme.mixins.toolbar,
  root: { width: "800px" },
  details: {
    display: "flex",
  },
  locationText: {
    paddingLeft: "15px",
  },
  errorText: {
    paddingLeft: "15px",
    color: "red",
  },
  input: {
    display: "none",
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  progess: {
    position: "absolute",
  },
  paperTable: {
    width: "100%",
    overflowX: "auto",
    maxHeight: 500,
  },
  assignText: {
    textAlign: "left",
  },
  assignButton: {
    position: "absolute",
    right: "0",
  },
  addButton: {
    marginTop: "10px",
    marginBottom: "10px",
    textTransform: "none",
  },
  deleteButton: {
    marginTop: "10px",
    marginLeft: "10px",
  },
  dialogeStyle: {
    maxWidth: "50%",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
});

export default withStyles(styles)(customerSectorName);
